import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../lang/i18n.js'
import axios from 'axios'
import router from '@/router/index'
import login from '@/store/modules/login.js'
import borradores from '@/store/modules/borradores.js'
import usuarios from '@/store/modules/usuarios.js'
import servicios from '@/store/modules/servicios.js'
import cierrescontables from '@/store/modules/cierrescontables.js'
import recepciones from '@/store/modules/recepciones.js'
import pedidos from '@/store/modules/pedidos.js'
import cierrescontablesBorradores from '@/store/modules/cierrescontablesBorradores.js'
import profile from '@/store/modules/profile.js'
import profiles from '@/store/modules/profiles.js'
import taxes from '@/store/modules/taxes.js'
import tareaspendientes from '@/store/modules/tareaspendientes.js'
import creacionFactura from '@/store/modules/creacionFactura.js'
import creacionAlbaran from '@/store/modules/creacionAlbaran.js'
import centros from '@/store/modules/centros.js'
import facturas from '@/store/modules/facturas.js'
import filtros from '@/store/modules/filtros.js'
import issues from '@/store/modules/issues.js'
import documentacion from '@/store/modules/documentacion.js'
import auditorias from '@/store/modules/auditorias.js'
import auditoriaAcciones from '@/store/modules/auditoriaAcciones.js'
import plantillasdecorreo from '@/store/modules/plantillasdecorreo.js'
import estadistica from '@/store/modules/statistics.js'
import albaranes from '@/store/modules/albaranes.js'
import cmr from '@/store/modules/cmr.js'
import genrals from '@/store/modules/genrals.js'
import procesosPlanificados from '@/store/modules/procesosPlanificados.js'
import mailServer from '@/store/modules/mailServer.js'
import ocrDocuments from '@/store/modules/ocrDocument.js'
import fn from '../utils/functions'


const browserLocale = require('browser-locale')

Vue.use(Vuex)

/*
  Serivicios Creados en Actions:

  USUARIO:
    1. action: login, url: '/session'
    1. action: logout, url: '/session'
    2. action: resetPassChallenge, url: '/forgottenpassword/challenge'
    2. action: resetPassChallengeSolved, url: '/forgottenpassword/challenge'
    3. action: getOptionsFilterInvoiceReceiveBuyer, url: '/me/partywithcommercialrelationship'
    3. action: getOptionsFilterEmitterAudits, url: '/me/partywithcommercialrelationship'
    3. action: getOptionsFilterReceiverAudits, url: '/me/partywithcommercialrelationship'
    4. action: getOptionsService, url: '/me/project'
    4. action: getUserProjectsList, url: '/me/project'
    5. url: '/me/protocol'

  DATOS FACTURAS:
    1. url: '/invoicenote'

  DATOS AUDITORIAS:
    1. url: '/auditorydocument'

  METODOS COMUNES (/constant/)
    1. url: '/constant/auditstatus'
    2. url: '/constant/communicationprotocol'
    3. url: '/constant/invoicestatus'
    4. url: '/constant/documentclass'
    5. url: '/constant/taxtype'
    6. url: '/constant/currency'
    7- action: getOptionsFilterFormatDocumentType, url: '/constant/documenttype/{documentTypeId}/format
    8. url: '/constant/accountingclosestatus'

*/

function deleteModulesFromStateLocal (copyLocal) {
  delete copyLocal.login
  delete copyLocal.usuarios
  delete copyLocal.borradores
  delete copyLocal.servicios
  delete copyLocal.recepciones
  delete copyLocal.pedidos
  delete copyLocal.cierrescontables
  delete copyLocal.cierrescontablesBorradores
  delete copyLocal.profile
  delete copyLocal.profiles
  delete copyLocal.taxes
  delete copyLocal.mailServer
  delete copyLocal.tareaspendientes
  delete copyLocal.creacionFactura
  delete copyLocal.creacionAlbaran
  delete copyLocal.centros
  delete copyLocal.facturas
  delete copyLocal.filtros
  delete copyLocal.issues
  delete copyLocal.documentacion
  delete copyLocal.auditorias
  delete copyLocal.auditoriaAcciones
  delete copyLocal.plantillasdecorreo
  delete copyLocal.procesosPlanificados
  delete copyLocal.estadistica
  delete copyLocal.albaranes
  delete copyLocal.genrals
  delete copyLocal.cmr
  delete copyLocal.ocrDocuments
}

function isNewVersion (state, local) {
  const copyLocal = JSON.parse(JSON.stringify(local))
  deleteModulesFromStateLocal(copyLocal)
  /*
   * Al .length de state.local tenemos que restarle 1 porque trae siempre una clave mas denominada
   * _ob_, que es un observador
  */
  if (state.local && copyLocal) {
    return (Object.getOwnPropertyNames(state.local).length - 1) !== Object.getOwnPropertyNames(copyLocal).length
  } else {
    return true
  }
}

/* Funcion para obtener el locale por defecto del navegador, quedándonos solo con el primer
* string representativo del idioma
*/
function getBrowserLocale () {
  const locale = browserLocale()
  const lang = locale.split('-')
  const langs = ['es','it','pt','en']
  if(langs.includes(lang[0])){
    return lang[0]
  } else {
    return 'en'
  }
}

function initSession () {
  const session = {
    // Usuario
    activeUser: {
      data: null,
      authToken: null,
      isActive: false
    },
    urlIn: null,
    primaryColor: null,
    secondaryColor: null,
    clientbg: null,
    jwt: null,
    recoveryPassUser: {
      username: null,
      question: null,
      answer: null,
      email: null
    },

    // Flags de permisos
    /* ADMIN */
    canCreateServices: false,
    canCreateParty: false,
    canCreateCentre: false,
    canAdminIndra: false,
    canModifyProject: false,
    canEditProjectDeliveryMethod: false,
    canEditPartyDeliveryMethod: false,
    canViewComercialRelation: false,
    canCreateComercialRelation: false,
    canAdminProject: false,
    canAdminParty: false,
    canAdminUser: false,
    canAdminPartyAdvanced: false,
    canViewBankData: false,
    canAdminProfile: false,
    canAdminQuartz: false,
    canChangePartyMedia: false,
    canModifyPaymentMethods: false,
    canViewDistributionCentres: false,
    canChangeCentreRoles: false,
    canEditOrDeleteCentreWithPermanentEstablishment: false,
    canAdminApprovalFlowByLevels: false,
    canUserApprovalFlowByLevels: false,

	/* MENU*/
	canViewMenu: false,
    /* PAYROLL */
    canSearchInvoiceSales: false,
    canSearchInvoicePurchases: false,
    canSearchInvoiceThird: false,
    /* DRAFT */
    canSearchInvoiceDraft: false,
    canCreateInvoiceDraft: false,
    canCopyInvoiceDraft: false,
    /* ACCOUNTING CLOSE */
    canSearchAccountingClose: false,
    canSearchAccountingCloseDraft: false,
    /* PENDING TAKS */
    canSearchPendingTasks: false,
    /* DOCUMENTOS OCR */
    canSearchOcrDocuments: false,
    /* DOCUMENT */
    canSeeSingDocument: false,
    canDeleteSingDocument: false,
    canAddSingDocument: false,
    /* INVOICE */
    canResendInvoices: false,
    canCreateCover: false,
    canAddBuyerCenter: false,
    canEditInvoices: false,
    canEditInternalNotes: false,
    canViewInternalNotes: false,
    canAddAttachments: false,
    canSeeAttachments: false,
    canSeeEvents: false,
    canSeeDocuments: false,
    canGetPaymentData: false,
    canSeeEventsBpm: false,    
    canDeleteAttachments: false,
    canSearchChannel: false,
    canCancelInvoice: false,
    canChangeStatusInvoice: false,
    canChangeSentFlagInvoice: false,
    canChangeStatusPendingTask: false,
    canViewRequestDigitalization: false,
    canDownloadFormatted: false,
    canViewStatusColor: false,
    canCreateDraftFromRecadv: false,
    canCreateCorrectiveInvoice: false,
    cantViewInvoiceSeriesCode: false,
    cantValidateOperationDate: false,
    canViewTotalIrpf: false,
    /* AUDITORY */
    canSearchDocumentAuditory: false,
    canSearchActionAuditory: false,
    /* DOCUMENTATION */
    canConsultDocumentation: false,
    canAdminDocumentation: false,
    /* STATISTICS */
    canConsulStatistics: false,
    /* RECADV */
    canSearchRecadvSender: false,
    canSearchRecadvReceiver: false,
    canRejectRecadv: false,
    canModifyRecadv: false,
    canCreateInvoiceRecadv: false,
    canCreateInvoiceParcialRecadv: false,
    canViewAttach: false,
    canCheckStatus: false,
    canChangeStatusRecadv: false,
    cantViewRecadvPdf: false,
    /* PEDIDOS */
    canSearchOrderSender: false,
    canSearchOrderReceiver: false,
    canChangeStatusOrder: false,
    canCreateDeliveryNoteOrder: false,
    canCreateInvoiceOrder: false,
    /* CARGA FACTURA */
    canUploadInvoice: false,
    /* USUARIOS */
    canAdminUserAdvanced: false,
    canNoEditUserData: false,    
    canViewMetadata: false,
    canViewMetadataPendingTask: false,
    canViewMetadataEmission: false,
    canViewOrderMetadata: false,
    canViewRecadvMetadata: false,
    canViewOrderOriginal: false,
    canViewRecadvOriginal: false,
    canViewDesadvMetadata: false,
    canViewDesadvOriginal: false,
    /* ADJUNTOS OCULTOS */
    canAttachmentHidden: false,
    /* CANAL RELACIONES COMERCIALES */
    canViewRelationChannel: false,
    /* ALBARANES */
    canSearchDeliverySender: false,
    canSearchDeliveryReceiver: false,
    canChangeStatusDeliveryNote: false,
    canCreateInvoiceDeliveryNote: false,
    /* GENRALS */
    canSearchGenralSender: false,
    canSearchGenralReceiver: false,
    /* ISSUES */
    canSearchIssue: false,
    canUpdateIssue: false,
    canDeleteIssue: false,
    canCreateIssue: false,
    /* CMR */
    canSearchCMR: false,
    canEditCMR: false,
    canChangeStatusCMR: false,

  }
  return session
}

function initialState () {
  const state = {
    userConfigLocalStorage: '',
    local: {
      // Nuevas
      activeLang: getBrowserLocale(),

      // Documentacion
      isShowDialogAddDocumentation: false,

      // Facturas
      invoice: {},

      // Constantes
      countries: [],
      invoiceStatus: [],

      // - Viejas - //
      invoiceModal: false,
      searchBarToggle: true,
      tableData: [],
      totalItemsTable: 100,
      invoiceFilters: {},
      ERRORS: [],
      distinctColumnData: [],
      isShowFactura: true,
      isShowEmision: true,
      isShowRegistro: true,
      isShowVendedor: true,
      isShowComprador: true,
      isShowImporte: true,
      isShowEstado: true
    },
    session: initSession()
  }
  return state
}

const store = new Vuex.Store({
  modules: {
    login,
    borradores,
    ocrDocuments,
    usuarios,
    servicios,
    recepciones,
    pedidos,
    cierrescontables,
    cierrescontablesBorradores,
    profile,
    profiles,
    taxes,
    mailServer,
    tareaspendientes,
    creacionFactura,
    creacionAlbaran,
    centros,
    facturas,
    filtros,
    issues,
    documentacion,
    auditorias,
    auditoriaAcciones,
    plantillasdecorreo,
    procesosPlanificados,
    estadistica,
    albaranes,
    genrals,
    cmr
  },

  state: initialState(),

  mutations: {
    // NUEVAS
    async initialStore (state) {
      // Check if the ID exists
      const session = JSON.parse(sessionStorage.getItem('store'))
      if (session) {
        // Aqui debemos declarar todos los modulos que insertemos en sessionStorage
        // con el siguiente formato:
        // state.<<modulo>>.sesion = session.<<modulo>>
        state.session = session
        state.usuarios.session = session.usuarios
        state.borradores.session = session.borradores
        state.servicios.session = session.servicios
        state.recepciones.session = session.recepciones
        state.pedidos.session = session.pedidos
        state.cierrescontables.session = session.cierrescontables
        state.cierrescontablesBorradores.session = session.cierrescontablesBorradores
        state.profile.session = session.profile
        state.profiles.session = session.profiles
        state.taxes.session = session.taxes
        state.mailServer.session = session.mailServer
        state.tareaspendientes.session = session.tareaspendientes
        state.creacionFactura.session = session.creacionFactura
        state.creacionAlbaran.session = session.creacionAlbaran
        state.centros.session = session.centros
        state.facturas.session = session.facturas
        state.issues.session = session.issues
        state.filtros.session = session.filtros
        state.documentacion.session = session.documentacion
        state.auditorias.session = session.auditorias
        state.auditoriaAcciones.session = session.auditoriaAcciones
        state.plantillasdecorreo.session = session.plantillasdecorreo
        state.procesosPlanificados.session = session.procesosPlanificados
        state.estadistica.session = session.estadistica
        state.albaranes.session = session.albaranes
        state.genrals.session = session.genrals
        state.cmr.session = session.cmr
        state.ocrDocuments.session = session.ocrDocuments
        this.replaceState(
          Object.assign(state, state)
        )
      }
      if (localStorage.getItem('local') === null) {
        console.log('STORE -- KO')
      } else {
        const local = JSON.parse(localStorage.getItem('local'))
        /*
        * Comprobamos que no se hayan insertado nuevos valores en local, ya que
        * si se han insertado, hay que machacar el contenido de localStorage con el state.local
        */
        const isnewVersionLocalStorage = await this.dispatch('isNewVersionLocalState', (state, local))
        if (isnewVersionLocalStorage) {
          localStorage.setItem('local', JSON.stringify(state.local))
          console.log('HAY NUEVA VERSION DE STATE.LOCAL')
        } else {
          // Obtenemos el valor del locale para el idioma
          i18n.locale = local.activeLang

          // Aqui debemos declarar todos los modulos que insertemos en localStorage
          // con el siguiente formato:
          // state.<<modulo>>.local = session.<<modulo>>
          state.local = local
          state.login.local = local.login
          state.usuarios.local = local.usuarios
          state.borradores.local = local.borradores
          state.servicios.local = local.servicios
          state.recepciones.local = local.recepciones
          state.pedidos.local = local.pedidos
          state.cierrescontables.local = local.cierrescontables
          state.cierrescontablesBorradores.local = local.cierrescontablesBorradores
          state.profile.local = local.profile
          state.profiles.local = local.profiles
          state.taxes.local = local.taxes
          state.mailServer.local = local.mailServer
          state.tareaspendientes.local = local.tareaspendientes
          state.creacionFactura.local = local.creacionFactura
          state.creacionAlbaran.local = local.creacionAlbaran
          state.centros.local = local.centros
          state.facturas.local = local.facturas
          state.issues.local = local.issues
          state.filtros.local = local.filtros
          state.documentacion.local = local.documentacion
          state.auditorias.local = local.auditorias
          state.auditoriaAcciones.local = local.auditoriaAcciones
          state.plantillasdecorreo.local = local.plantillasdecorreo
          state.procesosPlanificados.local = local.procesosPlanificados
          state.estadistica.local = local.estadistica
          state.albaranes.local = local.albaranes
          state.genrals.local = local.genrals
          state.cmr.local = local.cmr
          state.ocrDocuments.local = local.ocrDocuments
          this.replaceState(
            Object.assign(state, state)
          )
        }
        if (state.session.jwt === null) {
          // Para ahorrarnos la llamada al servicio
          console.log('STORE -- JWT NULL')
          console.log(state.session.urlIn)
          try {
            if (state.session.urlIn == null) {
              console.log('router ', router.currentRoute.name)
              if(router.currentRoute.name === 'consultInvoiceByLink') {
                router.push({ name: 'consultInvoiceByLink' }).catch(error => console.log('push exception', error))
              } else if (router.currentRoute.name === 'vocento') {
                router.push({ name: 'vocento' }).catch(error => console.log('push exception', error))
              } else {
                router.push({ name: 'login' }).catch(error => console.log('push exception', error))
              }
            } else {
              router.push({ name: fn.assignLoginName(state.session.urlIn) }).catch(error => console.log('push exception', error))
            }
          } catch (error) { console.log('Exception push') }
        } else {
          if(router.currentRoute.name === 'consultInvoiceByLink') {
            router.push({ name: 'consultInvoiceByLink' }).catch(error => console.log('push exception', error))
          } else if (router.currentRoute.name === 'vocento') {
            router.push({ name: 'vocento' }).catch(error => console.log('push exception', error))
          } else {
            axios.defaults.headers.common.Authorization = state.session.jwt
            console.log('STORE -- OK')
            router.push({
              name: 'b2b-app'
            })
          }
        }
      }
    },
    'ACTIVE_LANG_STATE' (state, payload) {
      state.local.activeLang = payload
      const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
      if (storeuser) {
        storeuser.activeLang = payload
        localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
      }
    },

    // Usuarios
    'ACTIVE_USER_STATE' (state, payload) {
      state.session.activeUser = payload
    },
    'JWT_STATE' (state, payload) {
      state.session.jwt = payload
    },
    'URL_IN_STATE' (state, payload) {
      state.session.urlIn = payload
    },
    'PRIMARY_COLOR_STATE' (state, payload) {
      state.session.primaryColor = payload
    },
    'SECONDARY_COLOR_STATE' (state, payload) {
      state.session.secondaryColor = payload
    },
    'CLIENTBG_COLOR_STATE' (state, payload) {
      state.session.clientbg = payload
    },
    'RECOVERY_PASS_USER_STATE' (state, payload) {
      state.session.recoveryPassUser = payload
    },

    // Datos constantes
    'COUNTRIES_LOADED' (state, payload) {
      state.local.countries = payload
    },
    'INVOICE_STATUS_LOADED' (state, status) {
      state.local.invoiceStatus = status
    },

    // - Viejas - //
    'INVOICE_MODAL_STATE' (state, payload) {
      state.local.invoiceModal = payload
    },
    'SEARCH_BAR_TOGGLE_STATUS' (state, payload) {
      state.local.searchBarToggle = payload
    },
    'REMOVE_INVOICE_FILTER' (state, payload) {
      state.local.invoiceFilters[payload.name].results = ''
      state.local.invoiceFilters[payload.name].selected = payload.value
    },
    'ADD_INVOICE_FILTER' (state, payload) {
      axios.get(payload.url, {
        params: {
          [payload.name]: payload.value
        }
      })
        .then(response => {
          state.local.invoiceFilters[payload.name].counter = response.data.length
          state.local.invoiceFilters[payload.name].results = payload.value
          console.log(response.data, '=', payload.value)
          state.local.invoiceFilters[payload.name].selected = true
        })
    },
    'ADD_FILTERS_JSON' (state, payload) {
      state.local.invoiceFilters = payload
    },
    'FILTER_TABLE' (state, payload) {
      state.local.tableData = payload
    },
    'GET_TOTAL_RESULTS' (state, payload) {
      state.local.totalItemsTable = payload
    },
    'DISTINCT_COLUMN' (state, payload) {
      state.local.distinctColumnData = payload
    },
    'IS_SHOW_FACTURA' (state, payload) {
      state.local.isShowFactura = payload
    },
    'IS_SHOW_EMISION' (state, payload) {
      state.local.isShowEmision = payload
    },
    'IS_SHOW_REGISTRO' (state, payload) {
      state.local.isShowRegistro = payload
    },
    'IS_SHOW_VENDEDOR' (state, payload) {
      state.local.isShowVendedor = payload
    },
    'IS_SHOW_COMPRADOR' (state, payload) {
      state.local.isShowComprador = payload
    },
    'IS_SHOW_IMPORTE' (state, payload) {
      state.local.isShowImporte = payload
    },
    'IS_SHOW_ESTADO' (state, payload) {
      state.local.isShowEstado = payload
    },
    // Set in the local
    'USER_CONFIG_SAVED' (state, payload) {
      console.log('user config: entro')
      if (localStorage.getItem(payload)) {
        const parseLocalStorage = JSON.parse(localStorage.getItem(payload))
        console.log('user config: parseLocalStorage: ', parseLocalStorage)

        if (!parseLocalStorage.login || !parseLocalStorage.usuarios || !parseLocalStorage.activeLang || !parseLocalStorage.countries ||
          !parseLocalStorage.borradores || !parseLocalStorage.servicios || !parseLocalStorage.cierrescontables || !parseLocalStorage.recepciones ||
          !parseLocalStorage.pedidos || !parseLocalStorage.cierrescontablesBorradores || !parseLocalStorage.tareaspendientes || !parseLocalStorage.creacionFactura ||
          !parseLocalStorage.centros || !parseLocalStorage.facturas || !parseLocalStorage.issues || !parseLocalStorage.filtros || !parseLocalStorage.documentacion || !parseLocalStorage.auditorias ||
          !parseLocalStorage.auditoriaAcciones || !parseLocalStorage.profiles || !parseLocalStorage.plantillasdecorreo || !parseLocalStorage.estadistica || !parseLocalStorage.creacionAlbaran ||
          !parseLocalStorage.taxes || !parseLocalStorage.mailServer || !parseLocalStorage.albaranes || !parseLocalStorage.genrals || !parseLocalStorage.procesosPlanificados || !parseLocalStorage.cmr || 
          !parseLocalStorage.ocrDocuments) {
          state.local = {
            ...state.local,
            ...parseLocalStorage,
            login: { ...state.local.login, ...parseLocalStorage.login },
            usuarios: { ...state.local.usuarios, ...parseLocalStorage.usuarios },
            borradores: { ...state.local.borradores, ...parseLocalStorage.borradores },
            servicios: { ...state.local.servicios, ...parseLocalStorage.servicios },
            cierrescontables: { ...state.local.cierrescontables, ...parseLocalStorage.cierrescontables },
            recepciones: { ...state.local.recepciones, ...parseLocalStorage.recepciones },
            pedidos: { ...state.local.pedidos, ...parseLocalStorage.pedidos },
            cierrescontablesBorradores: { ...state.local.cierrescontablesBorradores, ...parseLocalStorage.cierrescontablesBorradores },
            tareaspendientes: { ...state.local.tareaspendientes, ...parseLocalStorage.tareaspendientes },
            creacionFactura: { ...state.local.creacionFactura, ...parseLocalStorage.creacionFactura },
            creacionAlbaran: { ...state.local.creacionAlbaran, ...parseLocalStorage.creacionAlbaran },
            centros: { ...state.local.centros, ...parseLocalStorage.centros },
            facturas: { ...state.local.facturas, ...parseLocalStorage.facturas },
            issues: { ...state.local.issues, ...parseLocalStorage.issues },
            filtros: { ...state.local.filtros, ...parseLocalStorage.filtros },
            documentacion: { ...state.local.documentacion, ...parseLocalStorage.documentacion },
            auditorias: { ...state.local.auditorias, ...parseLocalStorage.auditorias },
            auditoriaAcciones: { ...state.local.auditoriaAcciones, ...parseLocalStorage.auditoriaAcciones },
            profiles: { ...state.local.profiles, ...parseLocalStorage.profiles },
            plantillasdecorreo: { ...state.local.plantillasdecorreo, ...parseLocalStorage.plantillasdecorreo },
            procesosPlanificados: { ...state.local.procesosPlanificados, ...parseLocalStorage.procesosPlanificados },
            taxes: { ...state.local.taxes, ...parseLocalStorage.taxes },
            mailServer: { ...state.local.mailServer, ...parseLocalStorage.mailServer },
            estadistica: { ...state.local.estadistica, ...parseLocalStorage.estadistica },
            albaranes: { ...state.local.albaranes, ...parseLocalStorage.albaranes },
            genrals: { ...state.local.genrals, ...parseLocalStorage.genrals },
            cmr: { ...state.local.cmr, ...parseLocalStorage.cmr },
            countries: state.local.countries,
            activeLang: state.local.activeLang
          }
        } else {
          if (parseLocalStorage.activeLang !== state.local.activeLang) {
            parseLocalStorage.activeLang = state.local.activeLang
          }
          if (parseLocalStorage.countries.length === 0) {
            parseLocalStorage.countries = state.local.countries
          }
          state.local = parseLocalStorage
        }
      } else {
        state.local.login = state.login.local
        state.local.usuarios = state.usuarios.local
        state.local.borradores = state.borradores.local
        state.local.servicios = state.servicios.local
        state.local.cierrescontables = state.cierrescontables.local
        state.local.recepciones = state.recepciones.local
        state.local.pedidos = state.pedidos.local
        state.local.cierrescontablesBorradores = state.cierrescontablesBorradores.local
        state.local.profile = state.profile.local
        state.local.profiles = state.profiles.local
        state.local.taxes = state.taxes.local
        state.local.mailServer = state.mailServer.local
        state.local.tareaspendientes = state.tareaspendientes.local
        state.local.creacionFactura = state.creacionFactura.local
        state.local.creacionAlbaran = state.creacionAlbaran.local
        state.local.centros = state.centros.local
        state.local.facturas = state.facturas.local
        state.local.issues = state.issues.local
        state.local.filtros = state.filtros.local
        state.local.documentacion = state.documentacion.local
        state.local.auditorias = state.auditorias.local
        state.local.auditoriaAcciones = state.auditoriaAcciones.local
        state.local.plantillasdecorreo = state.plantillasdecorreo.local
        state.local.procesosPlanificados = state.procesosPlanificados.local
        state.local.estadistica = state.estadistica.local
        state.local.albaranes = state.albaranes.local
        state.local.genrals = state.genrals.local
        state.local.cmr = state.cmr.local
        state.local.ocrDocuments = state.ocrDocuments.local
      }
      localStorage.setItem('local', JSON.stringify(state.local))
      localStorage.setItem(payload, JSON.stringify(state.local))
    }
  },

  actions: {
    // Crear key Usuario
    B2bCreateConfig ({ state, commit }) {
      // Manda el username a las computadas para su comprobacion en el storage
      const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
      if (B2bUserConfigSession.activeUser.data) {
        state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
        commit('USER_CONFIG_SAVED', B2bUserConfigSession.activeUser.data.username)
      }
    },
    // Funcion para resetear el sessionStorage cuando se hace logout.
    // IMPORTANTE incluir cada uno de los modules que contengan datos de sesión
    resetSession ({ state, commit }) {
      state.session = initSession()
      state.session.usuarios = commit('resetSessionUsuarios')
      state.session.borradores = commit('resetSessionBorradores')
      state.session.servicios = commit('resetSessionServicios')
      state.session.cierrescontables = commit('resetSessionCierresContables')
      state.session.recepciones = commit('resetSessionRecepciones')
      state.session.pedidos = commit('resetSessionPedidos')
      state.session.cierrescontablesBorradores = commit('resetSessionCierresContablesBorradores')
      state.session.profile = commit('resetSessionProfile')
      state.session.profiles = commit('resetSessionProfiles')
      state.session.tareaspendientes = commit('resetSessionTareasPendientes')
      state.session.taxes = commit('resetSessionTaxes')
      state.session.mailServer = commit('resetSessionMailServer')
      state.session.creacionFactura = commit('resetSessionCreacionFactura')
      state.session.creacionAlbaran = commit('resetSessionCreacionAlbaran')
      state.session.centros = commit('resetSessionCentros')
      state.session.facturas = commit('resetSessionFacturas')
      state.session.issues = commit('resetSessionIssues')
      state.session.filtros = commit('resetSessionFiltros')
      state.session.documentacion = commit('resetSessionDocumentacion')
      state.session.auditorias = commit('resetSessionAuditorias')
      state.session.auditoriaAcciones = commit('resetSessionAuditoriaAcciones')
      state.session.procesosPlanificados = commit('resetSessionPlannedProcesses')
      state.session.estadistica = commit('resetSessionEstadistica')
      state.session.albaranes = commit('resetSessionAlbaranes')
      state.session.genrals = commit('resetSessionGenrals')
      state.session.cmr = commit('resetSessionCmr')
      state.session.ocrDocuments = commit('resetSessionOcrDocuments')
    },

    // Funcion para definir el filtro rápido de fechas cuando se es superadmin
    datesSuperAdmin ({ state, commit }) {
      commit('auditsDatesSUperAdmin')
      commit('emittedPayrollsDatesSuperAdmin')
      commit('receivedPayrollsDatesSuperAdmin')
      commit('draftDatesSuperAdmin')
      commit('accountingCloseDatesSuperAdmin')
      commit('recadvDatesSuperAdmin')
      commit('draftAccountingCloseDatesSuperAdmin')
      commit('pendingTaskDatesSuperAdmin')
      commit('centresDatesSuperAdmin')
    },

    async isNewVersionLocalState ({ state, dispatch }, localStorage) {
      const isNewVersionLocalObject = isNewVersion(state, localStorage)
      const isNewVersionLoginLocalObject = await dispatch('isNewVersionLoginLocalState', localStorage)
      const isNewVersionUsuariosLocalObject = await dispatch('isNewVersionUsuariosLocalState', localStorage)
      const isNewVersionBorradoresLocalObject = await dispatch('isNewVersionBorradoresLocalState', localStorage)
      const isNewVersionServiciosLocalObject = await dispatch('isNewVersionServiciosLocalState', localStorage)

      const isNewVersionAuditoriaAccionesLocalObject = await dispatch('isNewVersionAuditoriaAccionesLocalState', localStorage)
      const isNewVersionPlantillasDeCorreoLocalObject = await dispatch('isNewVersionPlantillasDeCorreoLocalState', localStorage)
      const isNewVersionProcesosPlanificadosLocalObject = await dispatch('isNewVersionProcesosPlanificadosLocalState', localStorage)
      const isNewVersionRecepcionesLocalObject = await dispatch('isNewVersionRecepcionesLocalState', localStorage)
      const isNewVersionPedidosLocalObject = await dispatch('isNewVersionPedidosLocalState', localStorage)
      const isNewVersionCierresContablesLocalObject = await dispatch('isNewVersionCierresContablesLocalState', localStorage)
      const isNewVersionCierresContablesBorradoresLocalObject = await dispatch('isNewVersionCierresContablesBorradoresLocalState', localStorage)
      const isNewVersionProfileLocalObject = await dispatch('isNewVersionProfileLocalState', localStorage)
      const isNewVersionProfilesLocalObject = await dispatch('isNewVersionProfilesLocalState', localStorage)
      const isNewVersionTaxesLocalObject = await dispatch('isNewVersionTaxesLocalState', localStorage)
      const isNewVersionMailServerLocalObject = await dispatch('isNewVersionMailServerLocalState', localStorage)

      const isNewVersionTareasPendientesLocalObject = await dispatch('isNewVersionTareasPendientesLocalState', localStorage)
      const isNewVersionCreacionFacturaLocalObject = await dispatch('isNewVersionCreacionFacturaLocalState', localStorage)
      const isNewVersionCreacionAlbaranLocalObject = await dispatch('isNewVersionCreacionAlbaranLocalState', localStorage)
      const isNewVersionCentrosLocalObject = await dispatch('isNewVersionCentrosLocalState', localStorage)
      const isNewVersionFacturasLocalObject = await dispatch('isNewVersionFacturasLocalState', localStorage)
      const isNewVersionIssuesLocalObject = await dispatch('isNewVersionIssuesLocalState', localStorage)
      const isNewVersionFiltrosLocalObject = await dispatch('isNewVersionFiltrosLocalState', localStorage)
      const isNewVersionDocumentacionLocalObject = await dispatch('isNewVersionDocumentacionLocalState', localStorage)
      const isNewVersionEstadisticaLocalObject = await dispatch('isNewVersionEstadisticaLocalState', localStorage)
      const isNewVersionAlbaranesLocalObject = await dispatch('isNewVersionAlbaranesLocalState', localStorage)
      const isNewVersionGenralsLocalObject = await dispatch('isNewVersionGenralsLocalState', localStorage)
      const isNewVersionCmrLocalObject = await dispatch('isNewVersionCmrLocalState', localStorage)
      const isNewVersionOcrDocumentsLocalObject = await dispatch('isNewVersionOcrDocumentsLocalState', localStorage)

      const isNewVersionAuditoriasLocalObject = await dispatch('isNewVersionAuditoriasLocalState', localStorage)
      return isNewVersionLoginLocalObject || isNewVersionLocalObject || isNewVersionBorradoresLocalObject ||
            isNewVersionCentrosLocalObject || isNewVersionUsuariosLocalObject || isNewVersionServiciosLocalObject ||
            isNewVersionRecepcionesLocalObject || isNewVersionPedidosLocalObject || isNewVersionCierresContablesLocalObject || isNewVersionCierresContablesBorradoresLocalObject ||
            isNewVersionProfilesLocalObject || isNewVersionProfileLocalObject || isNewVersionTareasPendientesLocalObject || isNewVersionCreacionFacturaLocalObject ||
            isNewVersionCreacionAlbaranLocalObject || isNewVersionFacturasLocalObject || isNewVersionIssuesLocalObject || isNewVersionFiltrosLocalObject || 
            isNewVersionDocumentacionLocalObject || isNewVersionAuditoriasLocalObject || isNewVersionAuditoriaAccionesLocalObject ||
            isNewVersionPlantillasDeCorreoLocalObject || isNewVersionEstadisticaLocalObject || isNewVersionAlbaranesLocalObject || isNewVersionGenralsLocalObject ||
            isNewVersionTaxesLocalObject || isNewVersionMailServerLocalObject || isNewVersionProcesosPlanificadosLocalObject || isNewVersionCmrLocalObject ||
            isNewVersionOcrDocumentsLocalObject
    },

    // Detalles de usuario por username
    async getUserByUsername ({ commit, rootState }, data) {
      try {
        const response = await axios({
          method: 'GET',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/me/username',
          params: {
            username: data
          }
        })

        console.log('RESPONSE getUserByUsername:: ', response)
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error)
        throw error.response
      }
    },

    changeActiveLangState: ({
      commit, state
    }, lang) => {
      i18n.locale = lang
      commit('ACTIVE_LANG_STATE', lang)
      console.log('Pasa Por changeActiveLangState', lang)
      if (lang) {
        axios.defaults.headers.common['Accept-Language'] = lang
      }
      const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
      if (B2bUserConfigSession.activeUser.data) {
        state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
        commit('USER_CONFIG_SAVED', B2bUserConfigSession.activeUser.data.username)
      }
    },

    // Usuario
    activeUserState: ({
      commit
    }, payload) => {
      commit('ACTIVE_USER_STATE', payload)
    },
    jwtState: ({
      commit
    }, payload) => {
      commit('JWT_STATE', payload)
    },
    urlInState: ({
      commit
    }, payload) => {
      commit('URL_IN_STATE', payload)
    },
    primaryColorState: ({
      commit
    }, payload) => {
      commit('PRIMARY_COLOR_STATE', payload)
    },
    secondaryColorState: ({
      commit
    }, payload) => {
      commit('SECONDARY_COLOR_STATE', payload)
    },
    clientbgState: ({
      commit
    }, payload) => {
      commit('CLIENTBG_COLOR_STATE', payload)
    },
    recoveryPassUserState: ({
      commit
    }, payload) => {
      commit('RECOVERY_PASS_USER_STATE', payload)
    },
    //* - VIEJAS -//
    getJsonFiltersData: ({
      commit
    }, payload) => {
      commit('ADD_FILTERS_JSON', payload)
    },
    invoiceModalState: ({
      commit
    }, payload) => {
      commit('INVOICE_MODAL_STATE', payload)
    },
    searchBarToggleStatus: ({
      commit
    }, payload) => {
      commit('SEARCH_BAR_TOGGLE_STATUS', payload)
    },
    removeInvoiceFilter: ({
      commit
    }, payload) => {
      commit('REMOVE_INVOICE_FILTER', payload)
    },
    addInvoiceFilter: ({
      commit
    }, payload) => {
      commit('ADD_INVOICE_FILTER', payload)
    },
    filterTable: ({
      commit, state
    }, payload) => {
      const newParams = Object.assign({}, payload.params, payload.filters)
      return new Promise((resolve) => {
        axios.get(payload.url, {
          params: newParams
        }).then((response) => {
          commit('FILTER_TABLE', response.data)
          resolve()
        }).catch(e => {
          state.ERRORS.push(e)
        })
      })
    },
    getTotalResults: ({
      commit, state
    }, payload) => {
      return new Promise((resolve) => {
        axios.get(payload.url, {
          params: payload.filters
        })
          .then(response => {
            commit('GET_TOTAL_RESULTS', response.data.length)
            resolve()
          }).catch(e => {
            state.ERRORS.push(e)
          })
      })
    },
    isShowFactura: ({
      commit
    }, payload) => {
      commit('IS_SHOW_FACTURA', payload)
    },
    isShowEmision: ({
      commit
    }, payload) => {
      commit('IS_SHOW_EMISION', payload)
    },
    isShowRegistro: ({
      commit
    }, payload) => {
      commit('IS_SHOW_REGISTRO', payload)
    },
    isShowVendedor: ({
      commit
    }, payload) => {
      commit('IS_SHOW_VENDEDOR', payload)
    },
    isShowComprador: ({
      commit
    }, payload) => {
      commit('IS_SHOW_COMPRADOR', payload)
    },
    isShowImporte: ({
      commit
    }, payload) => {
      commit('IS_SHOW_IMPORTE', payload)
    },
    isShowEstado: ({
      commit
    }, payload) => {
      commit('IS_SHOW_ESTADO', payload)
    },
    getDistinctColumn: ({
      commit,
      state
    }, payload) => {
      const lookup = {}
      const result = []
      return new Promise((resolve) => {
        for (var item, i = 0; item = state.tableData[i++];) { // eslint-disable-line
          const name = item[payload]

          if (!(name in lookup)) {
            lookup[name] = 1
            const newObject = {
              name: name,
              value: name,
              selected: false
            }
            result.push(newObject)
          }
        }
        commit('DISTINCT_COLUMN', result)
        resolve()
      })
    },

    // Facturas
    // Constantes
    getCountries ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'GET',
          url: '/constant/country',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        })
          .then(response => {
            fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
            commit('COUNTRIES_LOADED', response.data)
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            resolve([])
            commit('COUNTRIES_LOADED', [])
          })
      })
    },

    // PERMISOS
    parseUserAuthorities ({
      state
    }) {
      console.log('Authorities: ', state.session.activeUser.data.authorities)
      return new Promise((resolve, reject) => {
        // ADMIN
        state.session.canCreateServices = state.session.activeUser.data.authorities.find(x => x === 'CREATE_PROJECT') !== undefined
        state.session.canCreateParty = state.session.activeUser.data.authorities.find(x => x === 'CREATE_PARTY') !== undefined
        state.session.canCreateCentre = state.session.activeUser.data.authorities.find(x => x === 'CREATE_CENTRE') !== undefined
        state.session.canAdminIndra = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_INDRA') !== undefined
        state.session.canModifyProject = state.session.activeUser.data.authorities.find(x => x === 'MODIFY_PROJECT') !== undefined
        state.session.canEditProjectDeliveryMethod = state.session.activeUser.data.authorities.find(x => x === 'PROJEC_DELIVERY_METHOD') !== undefined
        state.session.canEditPartyDeliveryMethod = state.session.activeUser.data.authorities.find(x => x === 'PARTY_DELIVERY_METHOD') !== undefined
        state.session.canViewComercialRelation = state.session.activeUser.data.authorities.find(x => x === 'VIEW_COMERCIAL_RELATION') !== undefined
        state.session.canCreateComercialRelation = state.session.activeUser.data.authorities.find(x => x === 'CREATE_COMERCIAL_RELATION') !== undefined
        state.session.canAdminProject = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_PROJECT') !== undefined
        state.session.canAdminParty = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_PARTY') !== undefined
        state.session.canAdminUser = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_USER') !== undefined
        state.session.canAdminPartyAdvanced = state.session.activeUser.data.authorities.find(x => x === 'ADVANCED_ADMIN_PARTY') !== undefined
        state.session.canViewBankData = state.session.activeUser.data.authorities.find(x => x === 'VIEW_BANK_DATA') !== undefined
        state.session.canAdminProfile = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_PROFILE') !== undefined
        state.session.canAdminProfiles = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_PROFILE') !== undefined
        state.session.canAdminTaxes = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_TAX') !== undefined
        state.session.canAdminQuartz = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_QUARTZ') !== undefined
        state.session.canAdminDocumentation = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_DOCUMENTATION') !== undefined
        state.session.canChangePartyMedia = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_PARTY_MEDIA') !== undefined  
        state.session.canModifyPaymentMethods = state.session.activeUser.data.authorities.find(x => x === 'MODIFY_PAYMENT_METHODS') !== undefined
        state.session.canViewDistributionCentres = state.session.activeUser.data.authorities.find(x => x === 'VIEW_DISTRIBUTION_CENTRES') !== undefined
        state.session.canChangeCentreRoles = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_CENTRE_ROLE') !== undefined
        state.session.canEditOrDeleteCentreWithPermanentEstablishment = state.session.activeUser.data.authorities.find(x => x === 'EDIT_CENTRE_PERMANENT_ESTABLISHMENT') !== undefined
        state.session.canAdminApprovalFlowByLevels = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_APPROVAL_FLOW_BY_LEVELS') !== undefined
        state.session.canUserApprovalFlowByLevels = state.session.activeUser.data.authorities.find(x => x === 'USER_APPROVAL_FLOW_BY_LEVELS') !== undefined


		state.session.canViewMenu = state.session.activeUser.data.authorities.find(x => x === 'VIEW_MENU') !== undefined
        // PAYROLL
        state.session.canSearchInvoiceSales = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_INVOICE_SALES') !== undefined
        state.session.canSearchInvoicePurchases = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_INVOICE_PURCHASES') !== undefined
        state.session.canSearchInvoiceThird = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_INVOICE_THIRD') !== undefined

        // DRAFT
        state.session.canSearchInvoiceDraft = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_INVOICE_DRAFT') !== undefined
        state.session.canCreateInvoiceDraft = state.session.activeUser.data.authorities.find(x => x === 'CREATE_INVOICE_DRAFT') !== undefined
        state.session.canCopyInvoiceDraft = state.session.activeUser.data.authorities.find(x => x === 'COPY_INVOICE') !== undefined

        // ACCOUNTING CLOSE
        state.session.canSearchAccountingClose = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_ACCOUNTING_CLOSE') !== undefined
        state.session.canSearchAccountingCloseDraft = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_ACCOUNTING_CLOSE_DRAFT') !== undefined

        // PENDING TASK
        state.session.canSearchPendingTasks = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_PENDING_TASKS') !== undefined

        // DOCUMENTOS OCR
        state.session.canSearchOcrDocuments = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_OCR_DOCUMENTS') !== undefined

        // DOCUMENTATION
        state.session.canSeeSingDocument = state.session.activeUser.data.authorities.find(x => x === 'CONSULT_SIGNDOCUMENT') !== undefined
        state.session.canDeleteSingDocument = state.session.activeUser.data.authorities.find(x => x === 'DELETE_SIGNDOCUMENT') !== undefined
        state.session.canAddSingDocument = state.session.activeUser.data.authorities.find(x => x === 'UPLOAD_SIGNDOCUMENT') !== undefined

        // INVOICE
        state.session.canResendInvoices = state.session.activeUser.data.authorities.find(x => x === 'FORWARD_INVOICE') !== undefined
        state.session.canCreateCover = state.session.activeUser.data.authorities.find(x => x === 'CREATE_COVER') !== undefined
        state.session.canAddBuyerCenter = state.session.activeUser.data.authorities.find(x => x === 'ADD_BUYER_CENTRE') !== undefined
        state.session.canEditInvoices = state.session.activeUser.data.authorities.find(x => x === 'EDIT_INVOICE_DATA') !== undefined
        state.session.canEditInternalNotes = state.session.activeUser.data.authorities.find(x => x === 'EDIT_INVOICE_NOTE') !== undefined
        state.session.canViewInternalNotes = state.session.activeUser.data.authorities.find(x => x === 'VIEW_INVOICE_NOTE') !== undefined
        state.session.canAddAttachments = state.session.activeUser.data.authorities.find(x => x === 'ADD_INVOICE_ATTACHMENTS') !== undefined
        state.session.canSeeAttachments = state.session.activeUser.data.authorities.find(x => x === 'VIEW_INVOICE_ATTACHMENT') !== undefined
        state.session.canSeeEvents = state.session.activeUser.data.authorities.find(x => x === 'VIEW_INVOICE_EVENTS') !== undefined
        state.session.canSeeDocuments = state.session.activeUser.data.authorities.find(x => x === 'VIEW_INVOICE_DOCUMENTS') !== undefined
        state.session.canGetPaymentData = state.session.activeUser.data.authorities.find(x => x === 'GET_PAYMENT_DATA') !== undefined        
        state.session.canSeeEventsBpm = state.session.activeUser.data.authorities.find(x => x === 'VIEW_INVOICE_BPM_EVENTS') !== undefined
        state.session.canDeleteAttachments = state.session.activeUser.data.authorities.find(x => x === 'DELETE_INVOICE_ATTACHMENTS') !== undefined
        state.session.canSearchChannel = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_CHANNEL') !== undefined
        state.session.canCancelInvoice = state.session.activeUser.data.authorities.find(x => x === 'CANCEL_INVOICE') !== undefined
        state.session.canChangeStatusPendingTask = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_STATUS_PENDINGTASKS') !== undefined
        state.session.canChangeStatusInvoice = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_INVOICE_STATUS') !== undefined
        state.session.canChangeSentFlagInvoice = state.session.activeUser.data.authorities.find(x => x === 'ADMIN_INDRA') !== undefined
        state.session.canViewRequestDigitalization = state.session.activeUser.data.authorities.find(x => x === 'VIEW_REQUEST_REDIGITALIZATION') !== undefined
        state.session.canDownloadFormatted = state.session.activeUser.data.authorities.find(x => x === 'DOWNLOAD_INVOIC_FORMATTED') !== undefined
        state.session.canViewStatusColor = state.session.activeUser.data.authorities.find(x => x === 'VIEW_INVALID_INVOICE_COLOR') !== undefined        
        state.session.canCreateDraftFromRecadv = state.session.activeUser.data.authorities.find(x => x === 'CREATE_INVOICE_FROM_RECADV') !== undefined
        state.session.canCreateCorrectiveInvoice = state.session.activeUser.data.authorities.find(x => x === 'CREATE_CORRECTIVE_INVOICE') !== undefined
        state.session.cantViewInvoiceSeriesCode = state.session.activeUser.data.authorities.find(x => x === 'NO_VIEW_INVOICE_SERIES_CODE') !== undefined
        state.session.canViewTotalIrpf = state.session.activeUser.data.authorities.find(x => x === 'TOTAL_IRPF') !== undefined


        // AUDITORY
        state.session.canSearchDocumentAuditory = state.session.activeUser.data.authorities.find(x => x === 'AUDITORY_DOCUMENT') !== undefined
        state.session.canSearchActionAuditory = state.session.activeUser.data.authorities.find(x => x === 'AUDITORY_ACTION') !== undefined

        // DOCUMENTATION
        state.session.canConsultDocumentation = state.session.activeUser.data.authorities.find(x => x === 'CONSULT_DOCUMENTATION') !== undefined
        // STATISTICS
        state.session.canConsulStatistics = state.session.activeUser.data.authorities.find(x => x === 'STATISTICS_MANAGEMENT') !== undefined
        // RECADV
        state.session.canSearchRecadvSender = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_RECADV_SENDER') !== undefined
        state.session.canSearchRecadvReceiver = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_RECADV_RECEIVER') !== undefined
        state.session.canRejectRecadv = state.session.activeUser.data.authorities.find(x => x === 'REJECT_RECADV') !== undefined
        state.session.canModifyRecadv = state.session.activeUser.data.authorities.find(x => x === 'MODIFY_RECADV') !== undefined
        state.session.canCreateInvoiceRecadv = state.session.activeUser.data.authorities.find(x => x === 'RECADV_CREATE_INVOICE') !== undefined
        state.session.canCreateInvoiceParcialRecadv = state.session.activeUser.data.authorities.find(x => x === 'RECADV_CREATE_INVOICE_PARCIAL') !== undefined
        state.session.canCheckStatus = state.session.activeUser.data.authorities.find(x => x === 'CHECK_STATUS') !== undefined
        state.session.canViewAttach = state.session.activeUser.data.authorities.find(x => x === 'RECADV_ATTACH') !== undefined
        state.session.canChangeStatusRecadv = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_STATUS_RECADV') !== undefined
        state.session.cantViewRecadvPdf = state.session.activeUser.data.authorities.find(x => x === 'NO_VIEW_RECADV_PDF') !== undefined

        // ORDER
        state.session.canSearchOrderSender = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_ORDER_SENDER') !== undefined
        state.session.canSearchOrderReceiver = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_ORDER_RECEIVER') !== undefined
        state.session.canChangeStatusOrder = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_STATUS_ORDER') !== undefined
        state.session.canCreateDeliveryNoteOrder = state.session.activeUser.data.authorities.find(x => x === 'ORDER_CREATE_DELIVERY_NOTE') !== undefined
		state.session.canCreateInvoiceOrder = state.session.activeUser.data.authorities.find(x => x === 'ORDER_CREATE_INVOICE') !== undefined
        // CARGA FACTURA
        state.session.canUploadInvoice = state.session.activeUser.data.authorities.find(x => x === 'UPLOAD_INVOICE') !== undefined
        // USUARIOS
        state.session.canAdminUserAdvanced = state.session.activeUser.data.authorities.find(x => x === 'ADVANCED_ADMIN_USER') !== undefined
        state.session.canNoEditUserData = state.session.activeUser.data.authorities.find(x => x === 'NO_EDIT_DATA_USER') !== undefined
        state.session.canViewMetadata = state.session.activeUser.data.authorities.find(x => x === 'VIEW_METADATA') !== undefined
        state.session.canViewMetadataPendingTask = state.session.activeUser.data.authorities.find(x => x === 'VIEW_METADATA_PENDINGTASK') !== undefined
        state.session.canViewMetadataEmission = state.session.activeUser.data.authorities.find(x => x === 'VIEW_METADATA_EMISSION') !== undefined
        state.session.canViewOrderMetadata = state.session.activeUser.data.authorities.find(x => x === 'VIEW_ORDER_METADATA') !== undefined
        state.session.canViewRecadvMetadata = state.session.activeUser.data.authorities.find(x => x === 'VIEW_RECADV_METADATA') !== undefined
        state.session.canViewOrderOriginal = state.session.activeUser.data.authorities.find(x => x === 'VIEW_ORDER_ORIGINAL') !== undefined
        state.session.canViewRecadvOriginal = state.session.activeUser.data.authorities.find(x => x === 'VIEW_RECADV_ORIGINAL') !== undefined
        state.session.canViewDesadvMetadata = state.session.activeUser.data.authorities.find(x => x === 'VIEW_DESADV_METADATA') !== undefined
        state.session.canViewDesadvOriginal = state.session.activeUser.data.authorities.find(x => x === 'VIEW_DESADV_ORIGINAL') !== undefined

        // ADJUNTOS OCULTOS
        state.session.canAttachmentHidden = state.session.activeUser.data.authorities.find(x => x === 'ATTACHMENT_HIDDEN') !== undefined
        // CANALES RELACIONES COMERCIALES
        state.session.canViewRelationChannel = state.session.activeUser.data.authorities.find(x => x === 'VIEW_RELATION_CHANNEL') !== undefined

        // ALBARANES
        state.session.canSearchDeliverySender = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_DELIVERY_SENDER') !== undefined
        state.session.canSearchDeliveryReceiver = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_DELIVERY_RECEIVER') !== undefined
        state.session.canChangeStatusDeliveryNote = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_STATUS_DELIVERYNOTE') !== undefined
        state.session.canCreateInvoiceDeliveryNote = state.session.activeUser.data.authorities.find(x => x === 'CREATE_INVOICE_FROM_DELIVERY_NOTE') !== undefined
        // GENRALS
        state.session.canSearchGenralSender = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_GENRAL_SENDER') !== undefined
        state.session.canSearchGenralReceiver = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_GENRAL_RECEIVER') !== undefined

        //ISSUES 
        state.session.canCreateIssue = state.session.activeUser.data.authorities.find(x => x === 'CREATE_ISSUE') !== undefined
        state.session.canSearchIssue = state.session.activeUser.data.authorities.find(x => x === 'SEARCH_ISSUE') !== undefined
        state.session.canUpdateIssue = state.session.activeUser.data.authorities.find(x => x === 'UPDATE_ISSUE') !== undefined
        state.session.canDeleteIssue = state.session.activeUser.data.authorities.find(x => x === 'DELETE_ISSUE') !== undefined
        
        // CMR
        state.session.canSearchCMR = state.session.activeUser.data.authorities.find(x => x === 'VIEW_CMR') !== undefined
        state.session.canEditCMR = state.session.activeUser.data.authorities.find(x => x === 'EDIT_CMR_DATA') !== undefined
        state.session.canChangeStatusCMR = state.session.activeUser.data.authorities.find(x => x === 'CHANGE_STATUS_CMR') !== undefined       
        
      })
    }

  },

  getters: {
    // NUEVOS
    getActiveLang: state => {
      return state.local.activeLang
    },
    // Usuario
    activeUser: state => {
      return state.session.activeUser
    },
    jwt: state => {
      return state.session.jwt
    },
    urlIn: state => {
      return state.session.urlIn
    },
    primaryColor: state => {
      return state.session.primaryColor
    },
    secondaryColor: state => {
      return state.session.secondaryColor
    },
    clientbg: state => {
      return state.session.clientbg
    },
    recoveryPassUser: state => {
      return state.session.recoveryPassUser
    },

    // Datos Tablas Facturas Emitidas
    invoice: state => {
      return state.local.invoice
    },

    // Constantes
    countries: state => {
      return state.local.countries
    },
    invoiceStatus: state => {
      return state.local.invoiceStatus
    },

    // FLAGS de permisos
    /* ADMIN */
    canCreateServices: state => {
      return state.session.canCreateServices
    },
    canCreateParty: state => {
      return state.session.canCreateParty
    },
    canCreateCentre: state => {
      return state.session.canCreateCentre
    },
    canAdminIndra: state => {
      return state.session.canAdminIndra
    },
    canModifyProject: state => {
      return state.session.canModifyProject
    },
    canEditProjectDeliveryMethod: state => {
      return state.session.canEditProjectDeliveryMethod
    },
    canEditPartyDeliveryMethod: state => {
      return state.session.canEditPartyDeliveryMethod
    },
    canViewComercialRelation: state => {
      return state.session.canViewComercialRelation
    },
    canCreateComercialRelation: state => {
      return state.session.canCreateComercialRelation
    },
    canAdminProject: state => {
      return state.session.canAdminProject
    },
    canAdminParty: state => {
      return state.session.canAdminParty
    },
    canChangePartyMedia: state => {
      return state.session.canChangePartyMedia
    },
    canModifyPaymentMethods: state => {
      return state.session.canModifyPaymentMethods
    },
    canAdminUser: state => {
      return state.session.canAdminUser
    },
    canAdminPartyAdvanced: state => {
      return state.session.canAdminPartyAdvanced
    },
    canAdminProfile: state => {
      return state.session.canAdminProfile
    },
    canAdminProfiles: state => {
      return state.session.canAdminProfiles
    },
    canAdminTaxes: state => {
      return state.session.canAdminTaxes
    },
    canAdminQuartz: state => {
      return state.session.canAdminQuartz
    },
    canAdminDocumentation: state => {
      return state.session.canAdminDocumentation
    },

    canViewBankData: state => {
      return state.session.canViewBankData
    },

    canViewDistributionCentres: state => {
      return state.session.canViewDistributionCentres
    },    
    canChangeCentreRoles: state => {
      return state.session.canChangeCentreRoles
    },
    canEditOrDeleteCentreWithPermanentEstablishment: state => {
      return state.session.canEditOrDeleteCentreWithPermanentEstablishment
    },
    canAdminApprovalFlowByLevels: state => {
      return state.session.canAdminApprovalFlowByLevels
    },
    canUserApprovalFlowByLevels: state => {
      return state.session.canUserApprovalFlowByLevels
    },
    /* MENU */
    canViewMenu: state => {
      return state.session.canViewMenu
    },
    /* PAYROLL */
    canSearchInvoiceSales: state => {
      return state.session.canSearchInvoiceSales
    },
    canSearchInvoicePurchases: state => {
      return state.session.canSearchInvoicePurchases
    },
    canSearchInvoiceThird: state => {
      return state.session.canSearchInvoiceThird
    },
    /* DRAFT */
    canSearchInvoiceDraft: state => {
      return state.session.canSearchInvoiceDraft
    },
    canCreateInvoiceDraft: state => {
      return state.session.canCreateInvoiceDraft
    },
    canCopyInvoiceDraft: state => {
      return state.session.canCopyInvoiceDraft
    },
    /* ACCOUNTING CLOSE */
    canSearchAccountingClose: state => {
      return state.session.canSearchAccountingClose
    },
    canSearchAccountingCloseDraft: state => {
      return state.session.canSearchAccountingCloseDraft
    },
    /* PENDING TASK */
    canSearchPendingTasks: state => {
      return state.session.canSearchPendingTasks
    },
    /* OCR - DOCUMENTOS PENDIENTES DE VALIDAR */
    canSearchOcrDocuments: state => {
      return state.session.canSearchOcrDocuments
    },
    /* DOCUMENT */
    canSeeSingDocument: state => {
      return state.session.canSeeSingDocument
    },
    canDeleteSingDocument: state => {
      return state.session.canDeleteSingDocument
    },
    canAddSingDocument: state => {
      return state.session.canAddSingDocument
    },
    /* INVOICE */
    canResendInvoices: state => {
      return state.session.canResendInvoices
    },
    canCreateCover: state => {
      return state.session.canCreateCover
    },
    canAddBuyerCenter: state => {
      return state.session.canAddBuyerCenter
    },
    canEditInvoices: state => {
      return state.session.canEditInvoices
    },
    canEditInternalNotes: state => {
      return state.session.canEditInternalNotes
    },
    canViewInternalNotes: state => {
      return state.session.canViewInternalNotes
    },    
    canAddAttachments: state => {
      return state.session.canAddAttachments
    },
    canSeeAttachments: state => {
      return state.session.canSeeAttachments
    },
    canSeeEvents: state => {
      return state.session.canSeeEvents
    },
    canSeeDocuments: state => {
      return state.session.canSeeDocuments
    },
    canGetPaymentData: state => {
      return state.session.canGetPaymentData
    },
    canSeeEventsBpm: state => {
      return state.session.canSeeEventsBpm
    },
    canDeleteAttachments: state => {
      return state.session.canDeleteAttachments
    },
    canSearchChannel: state => {
      return state.session.canSearchChannel
    },
    canCancelInvoice: state => {
      return state.session.canCancelInvoice
    },
    canChangeStatusPendingTask: state => {
      return state.session.canChangeStatusPendingTask
    },
    canChangeStatusInvoice: state => {
      return state.session.canChangeStatusInvoice
    },
    canChangeSentFlagInvoice: state => {
      return state.session.canChangeSentFlagInvoice
    },
    canViewRequestDigitalization: state => {
      return state.session.canViewRequestDigitalization
    },
    canDownloadFormatted: state => {
      return state.session.canDownloadFormatted
    },
    canViewStatusColor: state => {
      return state.session.canViewStatusColor
    },
    canCreateDraftFromRecadv: state => {
      return state.session.canCreateDraftFromRecadv
    },
    canCreateCorrectiveInvoice: state => {
      return state.session.canCreateCorrectiveInvoice
    },
    cantViewInvoiceSeriesCode: state => {
      return state.session.cantViewInvoiceSeriesCode
    },
    cantValidateOperationDate: state => {
      return state.session.cantValidateOperationDate
    },
    canViewTotalIrpf: state => {
      return state.session.canViewTotalIrpf
    },
    /* AUDITORY */
    canSearchDocumentAuditory: state => {
      return state.session.canSearchDocumentAuditory
    },
    canSearchActionAuditory: state => {
      return state.session.canSearchActionAuditory
    },
    /* DOCUMENTATION */
    canConsultDocumentation: state => {
      return state.session.canConsultDocumentation
    },
    /* STATISTICS */
    canConsulStatistics: state => {
      return state.session.canConsulStatistics
    },
    /* RECADV */
    canSearchRecadvSender: state => {
      return state.session.canSearchRecadvSender
    },
    canSearchRecadvReceiver: state => {
      return state.session.canSearchRecadvReceiver
    },
    canRejectRecadv: state => {
      return state.session.canRejectRecadv
    },
    canModifyRecadv: state => {
      return state.session.canModifyRecadv
    },
    canCreateInvoiceRecadv: state => {
      return state.session.canCreateInvoiceRecadv
    },
    canCreateInvoiceParcialRecadv: state => {
      return state.session.canCreateInvoiceParcialRecadv
    },
    canViewAttach: state => {
      return state.session.canViewAttach
    },
    canChangeStatusRecadv: state => {
      return state.session.canChangeStatusRecadv
    },
    cantViewRecadvPdf: state => {
      return state.session.cantViewRecadvPdf
    },
    /* ORDER */
    canSearchOrderSender: state => {
      return state.session.canSearchOrderSender
    },
    canSearchOrderReceiver: state => {
      return state.session.canSearchOrderReceiver
    },
    canChangeStatusOrder: state => {
      return state.session.canChangeStatusOrder
    },
    canCreateDeliveryNoteOrder: state => {
      return state.session.canCreateDeliveryNoteOrder
    },
    canCreateInvoiceOrder: state => {
      return state.session.canCreateInvoiceOrder
    },

    /* DELIVERY */
    canSearchDeliverySender: state => {
      return state.session.canSearchDeliverySender
    },
    canSearchDeliveryReceiver: state => {
      return state.session.canSearchDeliveryReceiver
    },
    canChangeStatusDeliveryNote: state => {
      return state.session.canChangeStatusDeliveryNote
    },
    canCreateInvoiceDeliveryNote: state => {
      return state.session.canCreateInvoiceDeliveryNote
    },    
    /* GENRAL */
    canSearchGenralSender: state => {
      return state.session.canSearchGenralSender
    },
    canSearchGenralReceiver: state => {
      return state.session.canSearchGenralReceiver
    },
    /* CMR */
    canSearchCMR: state => {
      return state.session.canSearchCMR
    },
    canEditCMR: state => {
      return state.session.canEditCMR
    },
    canChangeStatusCMR: state => {
      return state.session.canChangeStatusCMR
    },

    // CONSULTA ESTADOS
    canCheckStatus: state => {
      return state.session.canCheckStatus
    },
    // UPLOAD FACTURA
    canUploadInvoice: state => {
      return state.session.canUploadInvoice
    },

    // USUARIOS
    canAdminUserAdvanced: state => {
      return state.session.canAdminUserAdvanced
    },
    canNoEditUserData: state => {
      return state.session.canNoEditUserData
    },    
    canViewMetadata: state => {
      return state.session.canViewMetadata
    },
    canViewMetadataPendingTask: state => {
      return state.session.canViewMetadataPendingTask
    },
    canViewMetadataEmission: state => {
      return state.session.canViewMetadataEmission
    },
    canViewOrderMetadata: state => {
      return state.session.canViewOrderMetadata
    },
    canViewRecadvMetadata: state => {
      return state.session.canViewRecadvMetadata
    },
    canViewOrderOriginal: state => {
      return state.session.canViewOrderOriginal
    },
    canViewRecadvOriginal: state => {
      return state.session.canViewRecadvOriginal
    },
    canViewDesadvMetadata: state => {
      return state.session.canViewDesadvMetadata
    },
    canViewDesadvOriginal: state => {
      return state.session.canViewDesadvOriginal
    },

    // Adjuntos Ocultos
    canAttachmentHidden: state => {
      return state.session.canAttachmentHidden
    },

    // Canales Relaciones comerciales
    canViewRelationChannel: state => {
      return state.session.canViewRelationChannel
    },
    // ISSUES
    canSearchIssue: state => {
      return state.session.canSearchIssue
    },
    canUpdateIssue: state => {
      return state.session.canUpdateIssue
    },
    canDeleteIssue: state => {
      return state.session.canDeleteIssue
    },
    canCreateIssue: state => {
      return state.session.canCreateIssue
    },
    

    // - VIEJOS - //
    invoiceModal: state => {
      return state.local.invoiceModal
    },
    searchBarToggle: state => {
      return state.local.searchBarToggle
    },
    invoiceFilters: state => {
      return state.local.invoiceFilters
    },
    getSelectedFilters: state => {
      return Object.keys(state.local.invoiceFilters).map((k) => state.local.invoiceFilters[k]).filter(function (el) {
        return el.selected === true
      })
    },
    filterTable: state => {
      return state.local.tableData
    },
    totalResults: state => {
      return state.local.totalItemsTable
    },
    isShowFactura: state => {
      return state.local.isShowFactura
    },
    isShowEmision: state => {
      return state.local.isShowEmision
    },
    isShowRegistro: state => {
      return state.local.isShowRegistro
    },
    isShowVendedor: state => {
      return state.local.isShowVendedor
    },
    isShowComprador: state => {
      return state.local.isShowComprador
    },
    isShowImporte: state => {
      return state.local.isShowImporte
    },
    isShowEstado: state => {
      return state.local.isShowEstado
    },
    getDistinctColumn: state => {
      return state.local.distinctColumnData
    }
  }

  // plugins: [vuexPersistedDate({
  //   storage: {
  //     getState: (key) => Cookies.getJSON(key),
  //     setState: (key, state) => Cookies.set(key, state, { expires: 3, secure: true }),
  //     reducer: state => ({
  //       activeUserLocal: state.session.activeUser
  //     })
  //   }
  // })]
  // plugins: [vuexLocalStorage.plugin]
})

store.subscribe((mutation, state) => {
  // Insertar en local las propiedades correspondientes a los diferentes modulos
  state.local.login = state.login.local
  state.local.usuarios = state.usuarios.local
  state.local.borradores = state.borradores.local
  state.local.servicios = state.servicios.local
  state.local.recepciones = state.recepciones.local
  state.local.pedidos = state.pedidos.local
  state.local.cierrescontables = state.cierrescontables.local
  state.local.cierrescontablesBorradores = state.cierrescontablesBorradores.local
  state.local.profile = state.profile.local
  state.local.profiles = state.profiles.local
  state.local.taxes = state.taxes.local
  state.local.mailServer = state.mailServer.local
  state.local.tareaspendientes = state.tareaspendientes.local
  state.local.creacionFactura = state.creacionFactura.local
  state.local.creacionAlbaran = state.creacionAlbaran.local
  state.local.centros = state.centros.local
  state.local.facturas = state.facturas.local
  state.local.issues = state.issues.local
  state.local.filtros = state.filtros.local
  state.local.documentacion = state.documentacion.local
  state.local.auditorias = state.auditorias.local
  state.local.auditoriaAcciones = state.auditoriaAcciones.local
  state.local.plantillasdecorreo = state.plantillasdecorreo.local
  state.local.procesosPlanificados = state.procesosPlanificados.local
  state.local.estadistica = state.estadistica.local
  state.local.albaranes = state.albaranes.local
  state.local.genrals = state.genrals.local
  state.local.cmr = state.cmr.local
  state.local.ocrDocuments = state.ocrDocuments.local

  // Insertar en session las propiedades correspondientes a los diferentes modulos
  state.session.usuarios = state.usuarios.session
  state.session.borradores = state.borradores.session
  state.session.servicios = state.servicios.session
  state.session.cierrescontables = state.cierrescontables.session
  state.session.recepciones = state.recepciones.session
  state.session.pedidos = state.pedidos.session
  state.session.cierrescontablesBorradores = state.cierrescontablesBorradores.session
  state.session.profile = state.profile.session
  state.session.profiles = state.profiles.session
  state.session.taxes = state.taxes.session
  state.session.mailServer = state.mailServer.session
  state.session.tareaspendientes = state.tareaspendientes.session
  state.session.creacionFactura = state.creacionFactura.session
  state.session.creacionAlbaran = state.creacionAlbaran.session
  state.session.centros = state.centros.session
  state.session.facturas = state.facturas.session
  state.session.issues = state.issues.session
  state.session.filtros = state.filtros.session
  state.session.documentacion = state.documentacion.session
  state.session.auditorias = state.auditorias.session
  state.session.auditoriaAcciones = state.auditoriaAcciones.session
  state.session.plantillasdecorreo = state.plantillasdecorreo.session
  state.session.procesosPlanificados = state.procesosPlanificados.session
  state.session.estadistica = state.estadistica.session
  state.session.albaranes = state.albaranes.session
  state.session.genrals = state.genrals.session
  state.session.cmr = state.cmr.session
  state.session.ocrDocuments = state.ocrDocuments.session

  sessionStorage.setItem('store', JSON.stringify(state.session))
})

/* Captura el evento de acceso a local o session storage. Cuando pase, que se actualice
 * el valor del state . Esto es para cuando tengamos abierto a la vez varias pestañas
 * o ventanas
 */
window.addEventListener('storage', event => {
  if (event.newValue === null) return
  const local = JSON.parse(localStorage.getItem('local'))
  if (local) {
    // Aqui debemos declarar todos los modulos que insertemos en localStorage
    // con el siguiente formato:
    // state.<<modulo>>.local = session.<<modulo>>
    store.state.local = local
    store.state.usuarios.local = local.usuarios
    store.state.borradores.local = local.borradores
    store.state.servicios.local = local.servicios
    store.state.recepciones.local = local.recepciones
    store.state.pedidos.local = local.pedidos
    store.state.cierrescontables.local = local.cierrescontables
    store.state.cierrescontablesBorradores.local = local.cierrescontablesBorradores
    store.state.profile.local = local.profile
    store.state.profiles.local = local.profiles
    store.state.taxes.local = local.taxes
    store.state.mailServer.local = local.mailServer
    store.state.tareaspendientes.local = local.tareaspendientes
    store.state.creacionFactura.local = local.creacionFactura
    store.state.creacionAlbaran.local = local.creacionAlbaran
    store.state.centros.local = local.centros
    store.state.facturas.local = local.facturas
    store.state.issues.local = local.issues
    store.state.filtros.local = local.filtros
    store.state.documentacion.local = local.documentacion
    store.state.auditorias.local = local.auditorias
    store.state.auditoriaAcciones.local = local.auditoriaAcciones
    store.state.plantillasdecorreo.local = local.plantillasdecorreo
    store.state.procesosPlanificados.local = local.procesosPlanificados
    store.state.estadistica.local = local.estadistica
    store.state.albaranes.local = local.albaranes
    store.state.genrals.local = local.genrals
    store.state.cmr.local = local.cmr
    store.state.ocrDocuments.local = local.ocrDocuments

    store.replaceState(
      Object.assign(store.state, store.state)
    )
  }
})

export default store
